import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Form, Row, Col, Modal } from "react-bootstrap";
import { ButtonStandard } from '../../components'


import './ProviderToSubcontractorModal.scss';

import messages from "../../assets/i18n";

function ProviderToSubcontractorModal(props) {

	const lang = useSelector(state => state.language.name);
	const pageMessages = messages[lang].subcontractorDetailsPage;
	const dispatch = useDispatch();

	const providerList = useSelector(state => state.provider.fetchedProvidersNotLinkedSubcon.buscarFornecedorNaoVinculadoAoSubcontratado);
	const fetchedSubcontractor = useSelector(state => state.subcontractor.fetchedSubcontractorDetails);
	const isLoadingProviderUpdate = useSelector(state => state.provider.isLoadingProviderUpdate);


	const [validated, setValidated] = useState(false);

	const [formFields, setFormFields] = useState({
		fornecedor: '-1'
	});

	const handleSubmit = (event) => {
		let fornecedor = providerList.filter(i => i.id === parseInt(formFields.fornecedor))[0]
		const form = event.currentTarget;

		event.preventDefault();
		event.stopPropagation();

		if (form.checkValidity()) {
			dispatch({
				type: 'ADD_PROVIDER_SUBCONTRACTOR',
				payload: { fornecedorId: fornecedor.id, subcontratadoId: fetchedSubcontractor.id }
			})
		}

		setValidated(true);
		props.onHide();
	};

	return (
		<Modal
			{...props}
			aria-labelledby="contained-modal-title-vcenter"
			className="provider-to-subcontractor-modal"
			centered
		>
			<Form noValidate validated={validated} className="px-3" onSubmit={handleSubmit}>
				<Modal.Header className="text-center" closeButton>
					<Modal.Title className="w-100">{pageMessages.addFornecedor}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Row>
						<Form.Group as={Col} xs={12} className="mt-1">
							<Form.Label className="text-2">{pageMessages.fornecedor}</Form.Label>

							<Form.Control
								required
								as="select"
								className="text-2 border-radius-full"
								type="text"
								value={formFields.fornecedor}
								disabled={false}
								onChange={event => setFormFields(
									{ ...formFields, fornecedor: event.target.value },
								)}
							>
								{
									providerList.map(value => (
										<option key={value.id} value={value.id}>{value.nome}</option>
									))
								}
							</Form.Control>

							<Form.Control.Feedback type="invalid">
								{messages[lang].requiredField}
							</Form.Control.Feedback>
						</Form.Group>
					</Row>
				</Modal.Body>
				<Modal.Footer>
					<ButtonStandard
						id="norm_save_button"
						type="submit"
						text={messages[lang].save}
						textClass="text-2"
						disabled={formFields.fornecedor === '-1'}
						isLoading={isLoadingProviderUpdate}
						className="btn btn-primary btn-standard px-3 py-2 btn-primary btn-rounded" />
				</Modal.Footer>
			</Form>
		</Modal>
	)
}

export default ProviderToSubcontractorModal;